import * as actionType from './auditorAction';
import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import { Config } from '../../../config/config';
import Cookie from 'js-cookie';
import LZString from 'lz-string';
const config = JSON.parse(Config);
const apiInterface = config['api1'];
const initialState = {
    message: '',
    modalOpen: false,
    loading: false,
    apiStatus:false,
}
export const GetAuditorList = (data) => ({
    type: actionType.GET_AUDITOR_LIST,
    payload: data,
})
export const GetAuditorContractLIst = (data) => ({
    type: actionType.GET_AUDITOR_CONTRACT_LIST,
    payload: data,
})
export const apiStatus = (data) => ({
    type: actionType.API_CALL_STATUS,
    payload: data,
})
export const FilterAuditor = (data) => ({
    type: actionType.GET_SELECTED_AUDITOR,
    payload: data,
})
export const SelectedAuditor = (data) =>({
    type:actionType.GET_SELECTED_AUDITOR_FOR_SETTING,
    payload:data,
})
export const isEditAuditor = (payload) => ({
    type: actionType.IS_AUDITOR_EDIT,
    payload
})
export const isAuditorCreate = (payload) => ({
type: actionType.IS_AUDITOR_CREATE,
payload
})
export const isAuditorList = (payload) => ({
type: actionType.IS_AUDITOR_LIST,
payload
})
export const saveAuditorSupplyList = (payload) => ({
type: actionType.GET_AUDITOR_SUPPLY_LIST,
payload
})
  
export const getloadAuditorSupply=(auditor_row_id,record)=>async(dispatch)=>{
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    let data=[];
    record.auditorSupplyDetails.forEach(ele=>{
        data.push({
            ...ele,
            isEdit:true,
        })   
    })
    record.auditorSupplyDetails = data
    dispatch(FilterAuditor(record))  
//  ApiGateWay.PostCall1(apiInterface + '/AuditorInfo/loadauditorsupplydetails',value).then(res=>{console.log(res,'res')
//      let data=[]
//     if(res[0]?.Table1[0]?.status_code=='000'){
//         let supplyData=res[1]?.Table2;
//         supplyData.forEach(ele=>{
//             data.push({
//                 city_id:ele.city,
//                 state_id:ele.state,
//                 gst_number:ele.gst_number,
//                 third_number:ele.third_number,
//                 auditor_row_id:ele.auditor_row_id,
//                 auditor_supply_row_id:ele.auditor_supply_row_id,
//                 zone_id:ele.zone,
//                 isEdit:true,
//             })
          
//         })
//         record.supplyDetail=data;
//      dispatch(FilterAuditor(record))  ;
//     }else{
//         initialState.loading = false;
//         initialState.message = res[0]?.Table1[0]?.status_msg;
//         initialState.modalOpen = true;
//         dispatch(apiCallStatus(initialState))
//     }
  
//  }).catch(err=>{
//     initialState.loading = false;
//     dispatch(apiCallStatus(initialState))
//  })
}
export const getSelectedAuditor=(auditor_row_id,record)=>async(dispatch)=>{
    initialState.loading = true;
    console.log(record);
    console.log(auditor_row_id);
    dispatch(SelectedAuditor({auditorContractMappingInfos: record['auditorContractMappingInfos']}))
}
export const setAssetDetails = (payload) => {
    return{
        type: actionType.GET_ASSET_DETAILS,
        payload
}}
export const getAssetDetails=(payload)=>async(dispatch)=>{
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData)
    const value ={
        "fed_id":user["userId"],
        "store_id":payload.storeId,
        "auditor_id": payload.auditorId,
        "subcategory_id":payload.subcategoryId
    }
 ApiGateWay.GetAsset(apiInterface + '/AuditorInfo/updateassetlistforauditor',value).then(res=>{
    const result = JSON.parse(res);
    if(result[0].Table1[0].status_code === "000"){
        let data = result[1].Table2;
        return dispatch(setAssetDetails(data))
    }else{
        dispatch(setAssetDetails([]))
    }
  
 }).catch(err=>{
    initialState.loading = false;
    dispatch(apiCallStatus(initialState))
 })
}
export const doGetAuditorList = () => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SimpleGet(
        config['api2'] +
        '/api/fetchAuditorNContractDetails')
        .then((response) => {
            initialState.loading = false;
            // if (response[0]?.Table1[0]?.status_code == '000') {
            if (response) {
                const {
                    zoneInfo: ZoneList,
                    stateInfo: StateList,
                    cityInfo: CityList,
                    auditorDetail: AuditorList,
                    projectScopes: ProjectScopes,
                    storeInfo: StoreList

                } = response;
                // const AuditorList = (response[5]?.Table6).reverse();
                const uniqueIds = []
                const AuditorNameList = AuditorList.filter(element => {
                    const isDuplicate = uniqueIds.includes(element.id);
                    if (!isDuplicate) {
                        uniqueIds.push(element.id);
                        return true;
                    }
                    return false;
                });
                // AuditorList.forEach(element => {
                //    element.auditorStatus=element.auditorStatus==1?'Active':'InActive'; 
                // });
                console.log(AuditorList,'auditorList from AuditorService')
                const AuditorData = { StateList, ZoneList, CityList, ProjectScopes, AuditorList, AuditorNameList, StoreList }
                initialState.message = ''
                initialState.modalOpen=false;
                initialState.apiStatus = false;
                dispatch(GetAuditorList(AuditorData))
                dispatch(apiCallStatus(initialState))
            } else {
                initialState.message = response[0]?.Table1[0]?.status_msg;
                initialState.modalOpen = true;
                dispatch(apiCallStatus(initialState))
            }
        })
        .catch((e) => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}
export const SaveAuditorInfo = (values) => async (dispatch) => {
    console.log(values);
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SimplePost(config['api2'] + '/api/auditors', values)
        .then((result) => {
            initialState.loading = false;
            if (!result?.code?.includes("ERR")) {
                initialState.apiStatus= true;
                initialState.message = result?.status
                initialState.modalOpen = true;
                dispatch(apiCallStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.message = result.errorMessage
                dispatch(apiCallStatus(initialState))  
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}
export const UpdateAuditorInfo = (values) => async (dispatch) => {
    console.log(values);
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SimplePut(config['api2'] + '/api/updateauditors', values)
        .then((result) => {
            initialState.loading = false;
            if (!result?.code?.includes("ERR")) {
                initialState.apiStatus=true;
                initialState.message = result.status
                initialState.modalOpen = true;
                dispatch(apiCallStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.message = result.errorMessage
                dispatch(apiCallStatus(initialState))  
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}
export const SaveAuditorContractMappingInfo = (values) => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SimplePost(config['api2'] + '/api/auditorcontract', values)
        .then((result) => {
            initialState.loading = false;
            if (!result?.code?.includes("ERR")) {
                initialState.apiStatus=true;
                initialState.message = result.status
                initialState.modalOpen = true;
                dispatch(apiCallStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.message = result.errorMessage
                dispatch(apiCallStatus(initialState))  
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}
export const UpdateAuditorContractMappingInfo = (values) => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SimplePut(config['api2'] + '/api/updateauditorsContractDetails', values)
        .then((result) => {
            initialState.loading = false;
            if (!result?.code?.includes("ERR")) {
                initialState.apiStatus=true;
                initialState.message = result.status
                initialState.modalOpen = true;
                dispatch(apiCallStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.message = result.errorMessage
                dispatch(apiCallStatus(initialState))  
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}
export const doGetAuditorContractList = () => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SimpleGet(
        config['api2'] +
        '/api/fetchAuditorNContractDetails')
        .then((response) => {
            initialState.loading = false;
            // if (response[0]?.Table1[0]?.status_code == '000') {
                if (response) {
                const {
                    zoneInfo: ZoneList,
                    stateInfo: StateList,
                    cityInfo: CityList,
                    auditorDetail: AuditorList,
                    projectScopes: ProjectScopes,
                    storeInfo: StoreList

                } = response;
                const uniqueIds = []
                const AuditorNameList = AuditorList.filter(element => {
                    const isDuplicate = uniqueIds.includes(element.id);
                    if (!isDuplicate) {
                        uniqueIds.push(element.id);
                        return true;
                    }
                    return false;
                });
                const AuditorsContractMappingList= AuditorList.map((auditor)=> {
                    let stateArray = [];
                    let zoneArray = [];
                    auditor.auditorSupplyDetails.map((supplyDetails)=> {
                        stateArray.push(supplyDetails?.state);
                        zoneArray.push(supplyDetails?.zone);
                    })
                    return auditor.auditorContractMappingInfos.map((info)=> {
                        return {
                            ...info,
                            auditorName: auditor.auditorName,
                            contractStartDate: new Date(info.contractStartDate).toDateString(),
                            contractEndDate: new Date(info.contractEndDate).toDateString(),
                            state: stateArray.join(","),
                            zone: zoneArray.join(",")
                        }
                    })
                }).flat()
                const AuditorContractData = { ZoneList, StateList, CityList, AuditorList, StoreList, ProjectScopes, AuditorNameList, AuditorsContractMappingList}
                initialState.message = ''
                initialState.modalOpen = false
                initialState.apiStatus = false;
                dispatch(GetAuditorContractLIst(AuditorContractData))
                dispatch(apiCallStatus(initialState))
            } else {
                initialState.message = response[0]?.Table1[0]?.status_msg;
                initialState.modalOpen = true;
                dispatch(apiCallStatus(initialState))
            }
        })
        .catch((e) => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}
export const apiCallStatus = (data) => (dispatch) => {
    dispatch(apiStatus(data))
}
export const isEdit=(data)=>(dispatch)=>{
    dispatch(isEditAuditor(data))
}
export const addAuditor=(data)=>(dispatch)=>{
dispatch(isAuditorCreate(data))
}
export const AuditorList=(data)=>(dispatch)=>{
dispatch(isAuditorList(data))
}